// extracted by mini-css-extract-plugin
export default {"root":"style_root__RMZKJ","text":"style_text__mBzPn","toggle":"style_toggle__CTW7T","example":"style_example__lP5ma","warning":"style_warning__uKduw"};